{
  "elTimeRangePicker": {
    "liveDuration": "Live duration",
    "lockedTimeRange": "Time range is locked to this view",
    "selectRange": "Select a date range"
  },
  "IdleLogout": {
    "title": "Idle Logout",
    "description": "Log out users after a period of inactivity.",
    "idleLabel": "Idle timeout (in seconds)",
    "humanizedDuration": "That's about {{ duration }}.",
    "differenceWarning": "Your enterprise organization setting: {{ timeout }} seconds"
  },
  "LogoutRedirect": {
    "title": "Redirect after Logout",
    "redirectLabel": "Redirect URL",
    "samlDisclaimer": "This feature will not take effect if <b>SAML SLO</b> is set up.",
    "differenceWarning": "Your enterprise organization setting: {{ url }}"
  },
  "authProvider": {
    "configurationRequired": "configuration required",
    "local": {
      "title": "Local Sign-in",
      "description": "Allow users to sign-in using their credentials created on $t(common:companyName).",
      "hint": "Please log in using a different method to disable Local Sign-in."
    },
    "google": {
      "title": "Google Sign-in",
      "description": "Allow users to sign in via Google OAuth with an <strong>{{ domains }}</strong> email.",
      "hint": "Please log in using a different method to disable Google Sign-in."
    },
    "oauth": {
      "title": "Other OAuth Sign-in",
      "description": "Allow users to sign-in using OAuth credentials from other providers like <em>GitHub</em> or <em>Heroku</em>.",
      "hint": "Please log in using a different method to disable Other OAuth Sign-in."
    },
    "saml": {
      "title": "SAML Sign-in",
      "description": "Allow users to sign in via SAML.",
      "hint": "Please log in using a different method to disable SAML Sign-in."
    }
  },
  "saml": {
    "title": "SAML Configuration",
    "status": {
      "configured": "Configured",
      "pending": "Pending Configuration",
      "notConfigured": "Not Configured"
    },
    "dropMetadata": "Drop metadata.xml here to begin",
    "ssoRedirectUrl": "Single Sign On URL",
    "ssoConsumeUrl": "URL for the Single Sign On Service to Consume",
    "detailsLink": "Also known as the SAML Assertion Consumer Service (ACS) URL, your Identity Provider will need this information. Alternatively, you can also grab the <a href='{{ url }}' target='_blank'>service provider metadata here</a> for more details.",
    "configureManually": "configure manually",
    "signInUrlLabel": "Identity provider sign-in URL",
    "signInUrlDescription": "Supplied by your identity provider. Verifies users when they enter their work credentials.",
    "certificateTitle": "X.509 certificate",
    "certificateLabel": "Certificate",
    "removeCertificate": "Remove Certificate",
    "uploadNewMetadata": "Upload new metadata.xml",
    "saveConfig": "Save Config",
    "certificateDescription": "A .pem file security certificate supplied by your identity provider.",
    "SLOLabel": "Enable SAML Single Logout (SLO)",
    "idpSignOutURL": "Enter IdP signout URL",
    "suppliedByProvider": "Supplied by your identity provider.",
    "sloSignOutURL": "SLO signout URL",
    "spIssuer": "SP Issuer",
    "signatureCertificate": "Signature Certificate",
    "downloadCertificate": "Download Certificate",
    "sloDescription": "Enter these details in your IdP SLO settings. Users will need to log out and sign in again to apply the new SAML SLO settings.",
    "success": {
      "configurationUpdated": "SAML configuration updated successfully."
    },
    "errors": {
      "unableToExtractConfig": "Unable to extract SAML config from your {{ file }} file.",
      "unableToParseFile": "Encountered an error while trying to parse your {{ file }} file.",
      "unableToProcessFile": "Unable to process selected file",
      "unableToReadFile": "Unable to read selected file",
      "invalidCertificate": "Invalid certificate",
      "signinUrlRequired": "Provider sign-in URL is required.",
      "certificateRequired": "A valid certificate is required."
    }
  },
  "copyrightFooter": {
    "terms": "Terms",
    "privacy": "Privacy"
  },
  "typeahead": {
    "loading": "Searching…",
    "noResults": "No matches"
  },
  "dashboard": {
    "retry": "Retry",
    "noDataYet": "No data yet",
    "live": "LIVE",
    "now": "now",
    "loading": "Loading {{ title }}",
    "errorTitle": "Couldn’t load this card",
    "errorText": "The service didn’t respond. Other cards are unaffected.",
    "time": {
      "lessThanMinute": "<1 min",
      "minutes": "{{count}} min",
      "hours": "{{count}}h",
      "days": "{{count}}d",
      "justNow": "just now",
      "minutesAgo": "{{count}} min ago",
      "hoursAgo": "{{count}}h ago",
      "yesterday": "Yesterday",
      "daysAgo": "{{count}}d ago"
    }
  }
}
